import { render, staticRenderFns } from "./PolicyStatementsEditor.vue?vue&type=template&id=5e63f96c&scoped=true&"
import script from "./PolicyStatementsEditor.vue?vue&type=script&lang=js&"
export * from "./PolicyStatementsEditor.vue?vue&type=script&lang=js&"
import style0 from "./PolicyStatementsEditor.vue?vue&type=style&index=0&id=5e63f96c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e63f96c",
  null
  
)

export default component.exports